import React, { Component } from 'react';

import { translate } from 'react-i18next';
import { graphql } from 'react-apollo'
import { beginSurvey } from "../graphql/mutations.js"
import { sessionQuery } from "../graphql/queries.js"
import { withCookies } from 'react-cookie';

import Input from 'material-ui/Input';
import FlatUIButton from "../components/input/flat-ui-button.js";
import { CircularProgress } from 'material-ui/Progress';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';

import './setup.css';
// import Message from "../components/message.js";

// import Button from 'material-ui/Button';
// import Chip from 'material-ui/Chip';

class Setup extends Component {

  constructor(props) {
    super(props)
    this.state = {
      school_code: "",
      language: "en",
      error: window.Modernizr.cookies ? "" : props.t("cookies-disabled"),
      loading: false,
      openDialog: !!props.cookies.get("session_cookie")
    }

    // if (sessionStorage.getItem("session_id")) {
    //   // this.props.history.push('/m')
    //   this.setState({ openDialog: true })
    // }

    this.submit = this.submit.bind(this);
  }

  submit() {
    console.log(this.state)
    const { cookies } = this.props;

    this.setState({
      loading: true,
      error: ""
    })

    this.props.beginSurvey({ schoolCode: this.state.school_code, language: this.currentLang() })
        .then(({ data }) => {
          console.log(data)
          cookies.set("session_cookie", { 
              "session_id": data.beginSession.id, 
              "language": this.currentLang() 
            }, 
            { path: '/', maxAge: 48 * 60 * 60 })
          cookies.set('language_choices', data.beginSession.languages, { path: '/', maxAge: 60 * 60 })
          setTimeout(() => {
            if (data.beginSession.languages.length === 1) {
              this.props.i18n.changeLanguage(data.beginSession.languages[0])
              this.props.history.push('/m')
            } else {
              this.props.history.push('/l')
            }
          }, 250)
        })
        .catch((error) => {
          console.log(error)
          const graphqlMsg = error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].message
          this.setState({
            loading: false,
            error: graphqlMsg || error.message || "Error: " + error.code
          })
        })
  }

  currentLang() {
    const languages = ["en", "zh-HK", "zh-CN"]
    const userLangs = this.props.i18n.languages.filter(lng => languages.some(l => l === lng))
    // console.log(this.props.i18n.languages, userLangs)
    return userLangs[0] || 'en'
  }

  handleChange = event => {
    this.setState({
      school_code: event.target.value.trim()
    })
  }

  continueSession = event => {
    this.props.history.push('/m')
  }

  deleteSession = event => {
    // sessionStorage.setItem("session_id", data.beginSession.id)
    this.props.cookies.remove("session_cookie")
    this.setState({ openDialog: false })
  }

  render() {
    const { t } = this.props;
    // const currentLang = this.currentLang()

    return (
      <div className="setup-container">
        <div className="setup-spacer-small"/>
        <h1 className="white">
          #TrueFeels
        </h1>
        <p className="white tagline">
          {t("tagline")}
        </p>
        {/* <div>
          <FlatUIButton size="small" white 
              className={currentLang === 'en' ? "language-selected" : "language-unselected"}
              onClick={e => i18n.changeLanguage('en')}>
            EN
          </FlatUIButton>
          <FlatUIButton size="small" white
              className={currentLang === 'zh-CN' ? "language-selected" : "language-unselected"}
              onClick={e => i18n.changeLanguage('zh-CN')}>
            普通话
          </FlatUIButton>

          <FlatUIButton size="small" white
              className={currentLang === 'zh-HK' ? "language-selected" : "language-unselected"}
              onClick={e => i18n.changeLanguage('zh-HK')}>
            廣東話
          </FlatUIButton>
        </div> */}
        <p className="white setup-entry-label">
          {t('school_code')}
        </p>
        <div className="school-code-input-container">
          <Input
              id="school-code"
              color="primary"
              fullWidth
              inputProps={{maxLength: 4, autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: "false"}}
              value={this.state.school_code}
              onChange={this.handleChange.bind(this)}
              classes={{root: "school-code-input-root", input: "school-code-input"}}
            />
          </div>
          <FlatUIButton disabled={this.state.school_code.length !== 4 || !window.Modernizr.cookies} 
              className="rounded primary setup-submit-button" 
              onClick={e => this.submit()}>
            {t('ok')}
          </FlatUIButton>

          <div className="setup-spacer-large">
            { this.state.error && 
              <p className="error">
                { this.state.error }
              </p>
            }
            { this.state.loading && <CircularProgress /> }
          </div>

          <p className="setup-footer-text">
            {t("email-us-footer")} <a href="mailto:info@thebrightlyproject.com">info@thebrightlyproject.com</a>
          </p>

        <Dialog
          open={this.state.openDialog}
          onClose={this.continueSession}
          disableBackdropClick disableEscapeKeyDown
        >
          <DialogTitle>{t("cancel-session-title")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("cancel-session-description")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.deleteSession}>
              {t("reset-button")}
            </Button>
            <Button onClick={this.continueSession} color="primary" autoFocus>
              {t("continue-button")}
            </Button>
            
          </DialogActions>
        </Dialog>
          
      </div>
    );
  }
}

const TranslatedSetup = translate('translations')(Setup);

export default withCookies(
  graphql(
    beginSurvey, {
      props: ({ mutate, ownProps: { cookies } }) => ({
        beginSurvey: ({ schoolCode, language }) =>
          mutate({
            variables: { school_code: schoolCode, language: language },
            update: (proxy, { data: { beginSession }}) => {
              const queryData = { survey_session: beginSession }
              proxy.writeQuery({
                query: sessionQuery,
                variables: { id: beginSession.id },
                data: queryData
              })
            }
          })
      })
    }
  )(TranslatedSetup)
);



// WEBPACK FOOTER //
// ./src/pages/setup.js